/* eslint-disable import/order */
import React, { useMemo } from 'react'
import { groupBy } from 'lodash'
import { Stack } from '@sureco/design-system'
import ContentSection from 'layouts/ContentSection/ContentSection'
import CustomerDetails from '../components/CustomerDetails'
import ContactList from '../components/ContactList'

const ProfileTab = ({ customer, contacts }) => {
  const groupedContacts = useMemo(
    () => Object.entries(groupBy(contacts, 'type') ?? {}),
    [contacts]
  )

  return (
    <Stack space={20}>
      <ContentSection title="Customer Details">
        <CustomerDetails customer={customer} />
      </ContentSection>

      {groupedContacts.map(([key, group]) => (
        <ContentSection title={`${key} Contacts`} key={key}>
          <ContactList contacts={group} />
        </ContentSection>
      ))}
    </Stack>
  )
}

export default ProfileTab
